import { PATH } from '~/constants/enum';

const REDIRECT_URL = `${process.env.NEXT_PUBLIC_URL}`;
// const REDIRECT_URL = `http://localhost:3000`;

export const FB_CALLBACK_URI = PATH.ConnectFacebook;
export const FB_AUTH_SCOPE_PARAMS = '';
export const FB_SIGN_IN_URL = (fbAppId: any) =>
    `https://www.facebook.com/v21.0/dialog/oauth?client_id=${fbAppId}&redirect_uri=${REDIRECT_URL}${FB_CALLBACK_URI}&response_type=token&scope=email`;

export const GOOGLE_CALLBACK_URI = PATH.ConnectGoogle;
export const GOOGLE_SIGNIN_CLIENT_ID = '';
export const GOOGLE_SIGN_IN_URL = (ggAppId: any) =>
    `https://accounts.google.com/o/oauth2/auth?redirect_uri=${REDIRECT_URL}${GOOGLE_CALLBACK_URI}&response_type=code token id_token&scope=openid profile email&client_id=${ggAppId}`;
